import { ACTION_TYPES } from 'constants'

export const setContactDetails = (payload) => ({
  type: ACTION_TYPES.CONTACT_DETAILS,
  payload,
})
